import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { DatePipe } from '@angular/common';
import { NetworkingService } from '../shared/networking.service';

@Injectable()
export class ReportsService {

	public reportsData = {
	    "balance": {
	    	"url": "/reports/retrieve-balance-dashboard-intro",
	    	"columnDefs": ""
	    },
	    "commissions": {
	    	"url": "/reports/retrieve-commission-dashboard-intro",
	    	"node": "agencyCommissions",
	    	"columnDefs": [
	    		{
		          headerName: "Confirmation Number",
		          field: "confirmationNumber"
				},
		      	{
		          headerName: "Booking User Name",
		          field: "bookingUserName"
				},
		        {
		          headerName: "Originating Airport",
		          field: "originatingAirport"
				},
		        {
		          headerName: "Destination Airport",
		          field: "destinationAirport"
				},
		      	{
		          headerName: "IATA Number",
		          field: "iataNumber"
				},
		      	{
		          headerName: "Payment Date",
		          field: "paymentDate"
				},
		      	{
		          headerName: "Payment User Name",
		          field: "paymentUserName"
				},
		      	{
		          headerName: "Booking Currency",
		          field: "bookingCurrency"
				},
		      	{
		          headerName: "Booking Amount",
		          field: "bookingAmount"
				},
		      	{
		          headerName: "Payment Currency",
		          field: "paymentCurrency"
				},
		      	{
		          headerName: "Payment Amount",
		          field: "paymentAmount"
				},
		      	{
		          headerName: "Agency Commission",
		          field: "agencyCommission"
				},
		      	{
		          headerName: "Passenger Count",
		          field: "passengerCount"
				},
		        {
		          headerName: "Transaction Number",
		          field: "transactionNumber"
				}
		    ]
	    },
	    "transaction": {
	    	"url": "/reports/retrieve-transaction-dashboard-intro",
	    	"node": "agencyTransactions",
	    	"columnDefs": [
		      	{
		          headerName: "Booking User Name",
		          field: "bookingUserName"
		        },
		      	{
		          headerName: "Confirmation Number",
		          field: "confirmationNumber"
		        },
		      	{
		          headerName: "IATA Number",
		          field: "iataNumber"
		        },
		      	{
		          headerName: "Invoice Number",
		          field: "invoiceNumber"
		        },
		      	{
		          headerName: "Payment User Name",
		          field: "paymentUserName"
		        },
		      	{
		          headerName: "Transaction Amount",
		          field: "transactionAmount"
		        },
		      	{
		          headerName: "Transaction Balance",
		          field: "transactionBalance"
		        },
		      	{
		          headerName: "Transaction Currency",
		          field: "transactionCurrency"
		        },
		      	{
		          headerName: "Transaction Date",
		          field: "transactionDate"
		        },
		      	{
		          headerName: "Transaction IATA",
		          field: "transactionIATA"
		        },
		      	{
		          headerName: "Transaction Type",
		          field: "transactionType"
				}
		    ]
	    }
	};

	constructor(
		private networkingService: NetworkingService,
		private datePipe: DatePipe
	) { }

	getReports(formDetails, reportType) : Observable<any> {
		let reportUrl = this.reportsData[reportType]['url'];
	    return this.networkingService.get(reportUrl+'?IATANumber='+formDetails.iataNumber+'&requestedStartDate='+this.formatDate(formDetails.startDate)+'&requestedEndDate='+this.formatDate(formDetails.endDate))
	    .map(
	      response => {
	      	response.result.columnDefs = this.reportsData[reportType]['columnDefs'];
	        return response.result;
	      },
	      error => error
	    );
	}

	formatDate(date) {
    	return this.datePipe.transform(new Date(date), 'dd/MM/yyyy');
  	}
}


// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/reports/reports.service.ts